export var white = "#FFFFFF";
export var black = "#000000";
export var yellow = "#FBA72D";
export var pink = "#FF3A67";
export var green = "#29A87C";
export var blue = "#0074BD";
export var gray = "#333333";
export var red = "#de3618";
export var blue1 = "#F0FBFF";
export var blue2 = "#CFEBF6";
export var blue3 = "#64C2E7";
export var blue4 = "#0096D6";
export var blue5 = "#0074BD";
export var blue6 = "#152F50";
export var gray1 = "#FAFAFA";
export var gray2 = "#F5F5F5";
export var gray3 = "#DEDEDE";
export var gray4 = "#B8B8B8";
export var gray5 = "#747474";
export var gray6 = "#333333";
export var blue7 = "#F2F8FC";
export var yellow1 = "#FFFBF5";
export var green1 = "#F4FBF8";
export var pink1 = "#FFF5F7";
export var blue8 = "#80B9DE";
export var pink2 = "#FF9CB3";
export var gray7 = "#D9D9D9";
export var blue9 = "#6180C3";
export var yellow2 = "#F8B234";
export var purple1 = "#701B45";
export var blue012 = '#7083E7';
export var yellow3 = "#F8A72D";
export var green2 = "#339AA5";
export var blackTransparent05 = "rgba(0, 0, 0, 0.05)";
export var blackTransparent1 = "rgba(0, 0, 0, 0.1)";
export var blackTransparent15 = "rgba(0, 0, 0, 0.15)";
export var blackTransparent16 = "rgba(0, 0, 0, 0.16)";
export var blackTransparent25 = "rgba(0, 0, 0, 0.25)";
export var blackTransparent55 = "rgba(0, 0, 0, 0.55)";
export var blackTransparent85 = "rgba(0, 0, 0, 0.85)";
export var yellowTransparent1 = "rgba(248, 167, 45, 0.1)";
export var whiteTransparent8 = "rgba(255, 255, 255, 0.8)";
export var whiteTransparent7 = "rgba(255, 255, 255, 0.7)";
//# sourceMappingURL=colors.js.map